import { axiosInstance } from "../../../api/axiosInstance.tsx";

export interface RABSearchParams {
  keyword?: string;
  rabName?: string;
  projectId?: string;
  totalPrice?: string;
  projectReferenceId?: string;
  source?: string;
  projectType?: string;
  constructionPhase?: string;
  city?: string;
  state?: string;
  country?: string;
  latitude?: string;
  longitude?: string;
  salesProjectId?: string;
  startDate?: string;
  endDate?: string;
  startDateS?: string;
  endDateS?: string;
  startDateE?: string;
  endDateE?: string;
  valueEstimation?: string;
  valueMin?: string;
  valueMax?: string;
  limit?: number;
  offset?: number;
  orderBy?: string;
  order?: string;
}

export const getRab = async (params: RABSearchParams = {}) => {
  const parsedParams = params.limit? params : {limit: 1000000};
  const response = await axiosInstance.get("/sales/rab/search_rab", {
    params:parsedParams,
  });
  return response.data;
};


export const fetchRabPhotoBlob = async (filename: string): Promise<string | null> => {
  try {
    const token = localStorage.getItem("token");

    const response = await axiosInstance.get(`/sales/rab/photo/${filename}`, {
      responseType: "blob",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const objectUrl = URL.createObjectURL(response.data);
    return objectUrl;
  } catch (error) {
    console.error("Gagal mengambil foto:", error);
    return null;
  }
};



// Step 1: Create Project
export const createRab = async (data) => {
  const response = await axiosInstance.post(`/sales/rab/create_rab`, data);
  return response.data; // contains the project `id` or `code`
};


// Step 2: Upload Photo by Project ID
export const uploadRabPhoto = async (rabId, file) => {
  const formData = new FormData();
  formData.append("photo", file);

  return axiosInstance.post(`/sales/rab/upload_photo/${rabId}`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};


// Edit Project
export const editRab = async (data) => {
  const formData = {
    projectName: data.projectName,
    projectAddress: data.projectAddress,
    region: data.region,
    projectType: data.projectType,
    projectEmail: data.projectEmail,
    managerName: data.managerName,
    contactNumber: data.contactNumber,
  };

  const response = await axiosInstance.put(`/sales/rab/update_rab/${data.id}`, data);
  return response.data; // contains the project `id` or `code`
};

export const deleteRab = async (projectId: string) => {
  const response = await axiosInstance.delete(`/sales/rab/delete_rab/${projectId}`);
  return response.data;
};


// RAB DETAILS

export interface RABDetailSearchParams {
  keyword?: string;
  rabId?: string;
  ahsId?: string;
  volume?: string;
  totalHarga?: string;
  limit?: number;
  offset?: number;
  orderBy?: string;
  order?: string;
}

export const getRabDetail = async (params: RABDetailSearchParams = {}) => {
  const response = await axiosInstance.get("/sales/rab-detail/search_rab_detail", {
    params,
  });
  return response.data;
};

export const viewRabDetail = async (id: string) => {
  const response = await axiosInstance.get(`/sales/rab-detail/view_rab_detail/${id}`);
  return response.data;
};


export const createRabDetail = async (data) => {
  const response = await axiosInstance.post(`/sales/rab-detail/create_rab_detail`, data);
  return response.data; // contains the project `id` or `code`
};


export const editRabDetail = async (data) => {

  const response = await axiosInstance.put(`/sales/rab-detail/update_rab_detail/${data.id}`, data);
  return response.data; // contains the project `id` or `code`
};

export const deleteRabDetail = async (id: string) => {
  const response = await axiosInstance.delete(`/sales/rab-detail/delete_rab_detail/${id}`);
  return response.data;
};

// SCurve

export interface SCurveSearchParams {
  keyword?: string;
  rabDetailId?: string;
  rabId?: string;
  nilaiPekerjaan?: string;
  bobot?: string;
  durasiMinggu?: string;
  bobotMingguan?: string;
  limit?: number;
  offset?: number;
  orderBy?: string;
  order?: string;
}

export const getSCurve = async (params: SCurveSearchParams = {}) => {
  const response = await axiosInstance.get("/sales/scurve/search_scurve", {
    params,
  });
  return response.data;
};

export const viewSCurve = async (id: string) => {
  const response = await axiosInstance.get(`/sales/scurve/view_scurve/${id}`);
  return response.data;
};


export const createSCurve = async (data) => {
  const response = await axiosInstance.post(`/sales/scurve/create_scurve`, data);
  return response.data; // contains the project `id` or `code`
};


export const editSCurve = async (data) => {

  const response = await axiosInstance.put(`/sales/scurve/update_scurve/${data.id}`, data);
  return response.data; // contains the project `id` or `code`
};

export const deleteSCurve = async (id: string) => {
  const response = await axiosInstance.delete(`/sales/scurve/delete_scurve/${id}`);
  return response.data;
};